export const QUERY_KEY = {
  COMPANY_LIST: "companyList",
  INFINITE_COMPANY_LIST: "infiniteCompanyList",
  MY_INFO: "myInfo",
  TENANT_STATUS: "tenantStatus",
  AGENT_CONFIGS: "agentConfigs",
  CONVERSATION_LIST: "conversationList",
  CONVERSATION_MESSAGES: "conversationMessages",
  CONTACT_LOANS: "contactLoans",
  CONTACT_LOAN_SCENARIO: "contactLoanScenario",
  CONTACT_FINANCE_HISTORY: "contactFinanceHistory",
  CONTACT_BALANCE_HISTORY: "contactBalanceHistory",
  CONTACT_JOINT_VIEW: "contactJointView",
  CONTACT_MONEY_IN_OUT: "contactMoneyInOut",
  CONTACT_ACCOUNTS: "contactAccounts",
  CONTACT_PROPERTIES: "contactProperties",
  CONTACT_EXPENSES: "contactExpenses",
};
